import { useRef } from "react"
import { useAuth } from "../../context/AuthContext";
import AdminQuery from "./adminQuery";
import NotFound from "../../NotFound";

export default function Admin2({token, role} ){
    const displayRef = useRef(null);
    //const{ roles, email } = useAuth();

        if(role !== "cdlisAdmin"){
            return(<NotFound />)
        }
   
  
    return (
        <div>
            <div ref={displayRef}>
                <AdminQuery displayRef={displayRef}  token={token} />
            </div>
        </div>
    )
    
}